import { applyDrag } from '../components/DragAndDrop/utils';
import { defaultBannerNamePrefix } from '../config/defaults';
import jsondata from "../assets/elements.json";
import saveSettingsToLocalStorage from './settingsChanging';

let newsletterCounter = 0;
let textElementCounter = 0;

function checkListNameForSaveCurrentState(listName, stepsChange, prevCounter) {
    if (stepsChange !== true && listName === 'header') {
        this.updateChangesArray({typeData: [this.state.header, this.state.column], counter: prevCounter}, 4);
    } else if (stepsChange !== true && listName === 'mainBody') {
        this.updateChangesArray({typeData: this.state.mainBody, counter: prevCounter}, 5);
    } else if (stepsChange !== true && listName === 'footer') {
        this.updateChangesArray({typeData: this.state.footer, counter: prevCounter}, 6);
    } else if (stepsChange !== true && listName === 'cartBody') {
        this.updateChangesArray({typeData: this.state.cartBody, counter: prevCounter}, 7);
    } else if (stepsChange !== true && listName === 'productListBody') {
        this.updateChangesArray({typeData: this.state.productListBody, counter: prevCounter}, 8);
    } else {
        // No action required for other list names
    }
}

function saveCurrentState(listName, result, data='', stepsChange = false, multipleListNames = false) {
    const prevCounter = JSON.parse(localStorage.getItem('counterB2B')); 
    localStorage.setItem('counterB2B', JSON.stringify(this.counter));
    if(!multipleListNames) {
        if(listName === 'mainBody' && data !== '') {
            result = checkNewsletter(result, data);
        }
        localStorage.setItem(this.prefix + listName, JSON.stringify(result));
        checkListNameForSaveCurrentState.call(this, listName, stepsChange, prevCounter);
        this.setState({ [listName]: result });
        return;
    }
    const newStateObject = {};
    for(let i = 0; i < listName.length; i++) {
        localStorage.setItem(this.prefix + listName[i], JSON.stringify(result[i]));
        newStateObject[listName[i]] = result[i];
    }        
    if (stepsChange !== true) {
        this.updateChangesArray({typeData: [ this.state.mainBody, this.state.productListBody, this.state.cartBody ], counter: prevCounter}, 11);
    }
    this.setState(newStateObject);
}

function changeConfig(listName, index, config, stepsChange = false) {
    const element = Object.assign(this.getElement(listName, index));
    element.config = config;
    const list = [...(this.state[listName])];
    list[index] = element;
    saveCurrentState.call(this, listName, list, '', stepsChange);
}

function changeNameAndConfigForRecommended(elementInOptions, config, _recommendedType, stepsChange = false) {

    const element = {...elementInOptions.element}
    const listName = elementInOptions.listName;
    const index = elementInOptions.index;

    if (element.config !== config) {
        const newDataNamePrefix = getPluginFriendlyName(element.userFriendlyName, config);
        const previousDataNamePrefix = getPluginFriendlyName(element.userFriendlyName, element.config);
        element.name = element.name.replace(previousDataNamePrefix, newDataNamePrefix)
        element.config = config;
        const list = [...(this.state[listName])];
        list[index] = element;
        saveCurrentState.call(this, listName, list, '', stepsChange);
    }
}

function columnHandleListChange(addedItem, deletedItem, swapRemovedIndex) {
    if (addedItem.column !== undefined) {
        let columnNewResult = [...this.state.column];
        let isAlreadyAdded = false;
        for (const columnItem of columnNewResult) {
            if (columnItem.id === addedItem.column.id) {
                isAlreadyAdded = true;
                break;
            }
        }
        if (!isAlreadyAdded && !deletedItem) {
            if (addedItem.column.onTop) {
                columnNewResult.unshift(addedItem.column);  
            } else {
                columnNewResult.push(addedItem.column);  
            } 
        }
        if (isAlreadyAdded && deletedItem && swapRemovedIndex === -1) {
            columnNewResult = columnNewResult.filter(columnItem => columnItem.id !== addedItem.column.id);
        }
        saveCurrentState.call(this, 'column', columnNewResult, '');
    }
}

function handleListChange(listName, data) {
	data = checkTextElements(data);
    generateUniqueName.call(this, data.payload, listName);
    const oldUniqueIndex = getIndexOldUnique.call(this, listName, data.payload);
    const { result, addedItem, deletedItem, swapRemovedIndex } = applyDrag(this.state[listName], data, oldUniqueIndex);
    if (!isListChanged(result, this.state[listName])) {
        return;
    }
    const command = { listName: listName, removedIndex: data.removedIndex, addedIndex: data.addedIndex, payload: addedItem };
    if (deletedItem) {
        command.deletedItem = deletedItem;
        command.removedIndex = swapRemovedIndex;
        if(this.counter[deletedItem.id]) {
            this.counter[deletedItem.id] = this.counter[deletedItem.id] - 1;
        }
    }
    saveCurrentState.call(this, listName, result, data);

    columnHandleListChange.call(this, addedItem, deletedItem, swapRemovedIndex);

    saveSettingsToLocalStorage.call(
        this,
        this.state.colorSettings,
        this.state.currentThemeName
    )
}

const isListChanged = (currentList, previousList) => {
    const length = currentList.length;
    if (length !== previousList.length) {
        return true;
    }
    for (let i = 0; i < length; i++) {
        const x = currentList[i];
        const y = previousList[i];
        if (x.id !== y.id || x.type !== y.type) {
            return true;
        }
    }
    return false;
}

function getIndexOldUnique(listName, data) {
    if (data && data.isPopup && jsondata.uniquePopup.find(type => type === data.type)) {
        for (const typeElement of jsondata.uniquePopup) {
            if (typeElement !== data.type) {
                const elementToReplace = this.state[listName].find(element => element.type === typeElement);
                if (elementToReplace && elementToReplace.isPopup) {
                    return this.state[listName].indexOf(elementToReplace);
                }
            }
        }
    }
    let el = null;
    if (data && jsondata.uniqueTypes.find(type => type === data.type)) {
        el = this.state[listName].find(element => element.type === data.type)
    }
    if (el) {
        return this.state[listName].indexOf(el);
    }
    return -1;
}

function generateUniqueNameString(data, counterId, listName) {
    let namePart;
    if (data.userFriendlyName) {
        namePart = getPluginFriendlyName(data.userFriendlyName, data.config);
    } else {
        namePart = counterId;
    }
    return `${namePart}-${getListNameCode(listName)}-${this.counter[counterId]++}`;
}

/**
 * Generates unique names for creator elements that require them
 * @param {} data Element payload
 * @param {} listName Current page name
 */
function generateUniqueName(data, listName) {
    //data can be null when the element is being deleted
    if (!data) {
        return;
    }

    //we check if elem has pugin attached
    if (data.plugin !== null) {
        //unique name is required for recommended type in order to have import working
        if (data.type === 'newsSection' || data.type === 'textElement' || data.type === 'promotionalBanner') {
            const counterId = data.name || data.type;
            if (!this.counter[counterId]) {
                this.counter[counterId] = 1;
            }
            data.name = generateUniqueNameString.call(this, data, counterId, listName);
        }
        return;
        // u gory tutaj zmiana, ale trzeba ogarnac typ
    }
    // banners also need to have distinct names
    if (data.type === 'mainBanner') {
        if(listName==="productListBody"){
            data.name = `${defaultBannerNamePrefix}-${this.counter.bannerList++}-list` 
        }
        else{
            data.name = defaultBannerNamePrefix + this.counter.banner++;
        }
    }
    if(data.type === 'newsletter') {
        data.newsletterCounter = newsletterCounter;
        newsletterCounter++;
    }
}

/**
 * Function accepts string/string[] of translation names and config object of element. 
 * The functions returns object for name depending on element type, defined in src\assets\elements\<element>.js.
 * @param {string | string[]} translation - Name of translation/translations.
 * @param {Object} config - Object that represents element.
 * @returns {string | null} - Translated name/ Null if error.
 */
function getPluginFriendlyName(translation, config) {
    const PA_WORD_LIMIT = 18;
    if (!translation) {
        return;
    }
    if (typeof translation === "string") {
        if (translation.length > PA_WORD_LIMIT) {
            return translation.slice(0, PA_WORD_LIMIT);
        } else {
            return translation;
        }
    } else if (Array.isArray(translation)) {
        if (translation.length === 0) {
            return;
        }
        const typeNameIndex = getTypeFromConfig(config);
        if (translation.length < typeNameIndex || typeNameIndex === -1) { 
            return; 
        }
        if (translation[typeNameIndex].length > PA_WORD_LIMIT) {
            return translation[typeNameIndex].slice(0, PA_WORD_LIMIT);
        } else {
            return translation[typeNameIndex];
        }
    } else {
        return;
    }
}

function getTypeFromConfig(config) {
    if (!config) {
        return -1;
    }
    return parseInt(config.split(',')[2].split(':')[1], 10) - 1;
}

function getListNameCode(listName) {
    switch (listName) {
        case 'mainBody':
            return 'mp';
        case 'productListBody':
            return 'pl'; 
        case 'productBody':
            return 'pr'; 
        case 'cartBody':
            return 'cr';
        default:
            return listName;
    }
}

function checkTextElements(data) {
    if(data.payload) {
        if (data.payload.id === "textElement-1" || data.payload.id === "textElement-2") {
            textElementCounter++;
        }
        if (textElementCounter > 1) {
            data.payload.js = "";
        }
    } 
    return data;
}

function checkNewsletter(result, data) {
    if(!data.payload || data.payload.type !== 'newsletter') {
        return result;
    }
    
    for(let i=0;i<result.length;i++) {
        if(result[i].id === 'newsletter-1' || result[i].id === 'newsletter-2') {
            if(result[i].newsletterCounter !== data.payload.newsletterCounter) {
                const arr = result;
                arr.splice(i,1);
                result = arr;
            }
        }
    }

    for(let i=0;i<result.length;i++) {
        if(result[i].id === 'newsletter-3' && result[i].newsletterCounter !== data.payload.newsletterCounter) {
            const arr2 = result;
            arr2.splice(i,1);
            result = arr2;
        }
    }
    return result;
}
export { handleListChange, changeConfig, changeNameAndConfigForRecommended, saveCurrentState, generateUniqueName };